import api from './api';

const vendorAuthService = {
  // Vendor login
  login: async (email, password) => {
    const response = await api.post('/vendor-auth/login', { email, password });
    if (response.data.token) {
      localStorage.setItem('vendorToken', response.data.token);
      localStorage.setItem('vendorData', JSON.stringify(response.data.vendor));
    }
    return response.data;
  },

  // Vendor logout
  logout: () => {
    localStorage.removeItem('vendorToken');
    localStorage.removeItem('vendorData');
  },

  // Get current vendor profile
  getProfile: async () => {
    const response = await api.get('/vendors/profile');
    return response.data;
  },

  // Update vendor profile
  updateProfile: async (profileData) => {
    const response = await api.put('/vendors/profile', profileData);
    return response.data;
  },

  // Change password
  changePassword: async (currentPassword, newPassword) => {
    const response = await api.post('/vendor-auth/change-password', {
      currentPassword,
      newPassword
    });
    return response.data;
  },

  // Upload profile picture
  uploadProfilePicture: async (formData) => {
    const response = await api.post('/vendors/profile/picture', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Remove profile picture
  removeProfilePicture: async () => {
    const response = await api.delete('/vendors/profile/picture');
    return response.data;
  },

  // Get stored vendor data
  getStoredVendorData: () => {
    const vendorData = localStorage.getItem('vendorData');
    return vendorData ? JSON.parse(vendorData) : null;
  },

  // Check if vendor is authenticated
  isAuthenticated: () => {
    return !!localStorage.getItem('vendorToken');
  }
};

export default vendorAuthService;

